var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.log)?_c('pre',{staticClass:"log-viewer"},[_vm._v(_vm._s(_vm.log))]):_c('p',{staticClass:"log-viewer"},[_vm._v("Не удалось прочитать файл лога")])}
var staticRenderFns = []

export { render, staticRenderFns }